import React from 'react';
import { Update, UpdatesProps } from '../types';

export const Updates: React.FC<UpdatesProps> = ({ updates, onMarkAsRead }) => {
  const getUpdateTypeColor = (type: string) => {
    switch (type) {
      case 'feature':
        return 'bg-green-100 text-green-800';
      case 'bugfix':
        return 'bg-red-100 text-red-800';
      case 'improvement':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-900">Updates</h1>
            </div>

            <div className="space-y-4">
              {updates.map((update) => (
                <div
                  key={update.id}
                  className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                >
                  <div className="p-4">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-2">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getUpdateTypeColor(
                              update.type
                            )}`}
                          >
                            {update.type}
                          </span>
                          <span className="text-sm text-gray-500">
                            {new Date(update.createdAt).toLocaleDateString()}
                          </span>
                        </div>
                        <h3 className="mt-1 text-lg font-medium text-gray-900">{update.title}</h3>
                        <p className="mt-2 text-sm text-gray-600">{update.description}</p>
                      </div>
                      {!update.isRead && (
                        <button
                          onClick={() => onMarkAsRead(update.id)}
                          className="ml-4 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-[#06B6D4] bg-[#06B6D4]/10 hover:bg-[#06B6D4]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#06B6D4]"
                        >
                          Mark as Read
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 